<template>
  <Section class="pb-0">
    <template #header>
      <div class="mr-auto">
        <strong>Add A Payment Method</strong>
      </div>
      <v-btn fab x-small rounded dark class="ml-2" color="primary" :to="{ name: 'billing/new_payment_method'}">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </template>

    <div v-if="needsDefault" class="mx-n3 mt-1">
      <v-divider />
      <div class="text-center red--text">
        Please choose a default payment method.
      </div>
    </div>
    
    <v-list dense two-line class="rounded-lg py-0 mx-n3">
      <template v-for="method,i in paymentMethods">
        <v-divider :key="`divider-${i}`" class="my-1"/>
        <v-list-item :key="method.payment_method_id" class="d-flex align-center">
          <div class="d-flex align-center justify-center" style="width: 60px; height: 60px;">
            <CardLogo :brand="method.brand" />
          </div>
          <div class="pl-2">
            <div>
              Ending in {{ method.last4 }}
            </div>
            <div>
              Expires {{ method.expires }}
            </div>
          </div>
          <div class="text-center px-4 font-italic ml-auto mr-auto">{{ method.default ? 'Default' : '' }}</div>
          <div class="ml-auto">
            <PaymentMethodMenu :payment_method="method" :count="paymentMethods.length"
              @setDefaultMethod="setDefaultMethodClick"
              @deleteMethod="deleteMethodClick"
            />
          </div>
        </v-list-item>
      </template>
    </v-list>
  </Section>
</template>

<script>
import { Section } from '@/components/pages'
import CardLogo from '@/components/CardLogo'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import PaymentMethodMenu from './PaymentMethodMenu'


export default {
  name: 'PaymentMethodsSection',

  components: { 
    CardLogo,
    PaymentMethodMenu,
    Section,
  },

  computed: {
    ...mapGetters('payment_methods', ['paymentMethods']),

    needsDefault() {
      return this.paymentMethods.length > 0 && !this.paymentMethods.reduce( (a,b) => a || b.default, false )
    }
  },

  methods: {
    ...mapActions('payment_methods', ['loadPaymentMethods', 'setDefaultMethod', 'deleteMethod']),
    ...mapMutations('alerts', ['SNOOZE']),

    async setDefaultMethodClick(payment_method) {
      await this.setDefaultMethod({payment_method: payment_method.payment_method_id})
    },

    async deleteMethodClick(payment_method) {
      this.SNOOZE('payment_method')
      await this.deleteMethod({ payment_method: payment_method.payment_method_id})
    },
  },

  async created() {
    const { name, params, query } = this.$route
    const { refill }  = query

    if( query.redirect_status == 'succeeded' && query.setup_intent ) {
      await this.setDefaultMethod({ setup_intent: query.setup_intent, refill } )

      this.$router.replace({ name, params })
    } else {
      this.loadPaymentMethods()
    }
  },
}
</script>
